import common from './common.json';
import sys from './sys.json';

export default {
  ...common,
  ...sys,
};
